export const BroadcastMessageFieldLevelError = (
  errorFieldObject,
  errorFromApi
) => {
  const fieldMapping = {
    errorBrand: "brand",
    errorName: "name",
    errorSendTime: "sendTime",
    errorCustomerDataType: "customerDataType",
    errorFileKey: "fileKey",
    errorType: "type",
    errorMessageTemplate: "messageTemplate",
    errorMessageTemplateSms: "messageTemplateSms",
    errorMessageTemplateLine: "messageTemplateLine",
    errorImageRelativePath: "imageRelativePath",
    errorTargetUrl: "targetUrl",
    errorPreviewImageRelativePath: "previewImageRelativePath",
    errorVideoRelativePath: "videoRelativePath",
    errorMessageTemplatePushNoti: "messageTemplatePushNoti",
    errorPushNotiTargetUrl: "pushNotiTargetUrl",
    errorShowInInbox: "showInInbox",
    errorShowUntil: "showUntil",
    errorMessageTitle: "messageTitle",
  };

  for (const [errorKey, fieldName] of Object.entries(fieldMapping)) {
    errorFieldObject[errorKey] = errorFromApi.find(
      (e) => e.fieldName === fieldName
    );
  }
};
